import { errorHandler } from '../exports/error_management'
const AWS = require('aws-sdk')


const state = {

}

const getters = {}

const mutations = {

}

const actions = {
    //upload recent quickbook to AMS
    async runSynchronizer({ dispatch, rootState, rootGetters }) {
        try {

            const FunctionName = `arn:aws:lambda:us-east-1:481228531267:function:OMS-SYNCHRONIZER${rootGetters.is_development ? '' : ':PROD'}`
            await dispatch('js_report/fetchCredentials', {}, { root: true })

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                region,
            } = rootState.js_report.aws_credentials

            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            AWS.config.update(options)
            const lambda = new AWS.Lambda()

            const { hostname: api_host } = new URL(rootGetters.baseURL)


            const Payload = JSON.stringify({
                api_host
            })

            const params = {
                FunctionName,
                Payload,
            }

            const { Payload: resp } = await lambda.invoke(params).promise()

            const { statusCode, body } = JSON.parse(resp);

            if (statusCode != 200) throw new Error(body)
        } catch (err) {
            errorHandler(err)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}